export default __webpack_public_path__ + "static/media/prize-2-bm.3d82dd90.webp";